/**
 * Custom functionality for the Where to Buy page.
 */

/* global jQuery */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process
const qs = require('../utilities/querystring');

// const DESTINI_URL = '//destinilocators.com/michaelangelos/site/install/"';      // New URL. Not working w this code.
const DESTINI_URL = '//destinilocators.com/michaelangelos/site/locator.php'; // Original URL.

/**
 * Init our product locator (Destini) widget
 */
function initDestini() {
    let loc = qs.getParam('location'),
        scriptPath = DESTINI_URL;

    if ((loc !== null) && (loc !== '')) {
        scriptPath += '?MM=panel2&ZIP=' + loc;
    } else {
        scriptPath += '?MM=panel1';
    }

    $('#destini').attr('src', scriptPath);

}




exports.init = function () {
    initDestini();
};